/**
 * Hace VISIBLE un fallo de escritura.
 *
 * «Los writes offline no desaparecen en silencio» (CA-8.1). Como ninguna
 * pantalla cierra su formulario hasta que la escritura confirma, lo tecleado no
 * se pierde: esto solo evita que el fallo pase desapercibido.
 *
 * Escucha a nivel de aplicación, así que no hace falta envolver cada
 * `repo.guardar(...)` en un try/catch.
 */

import { useEffect, useState } from 'react';
import { EscrituraFallidaError } from '../persistencia/db';
import estilos from './AvisoEscrituraFallida.module.css';

export function AvisoEscrituraFallida() {
  const [mensaje, setMensaje] = useState<string | null>(null);

  useEffect(() => {
    function alFallar(evento: PromiseRejectionEvent) {
      const razon = evento.reason;
      if (razon instanceof EscrituraFallidaError) {
        setMensaje(razon.message);
        console.error(razon.operacion, razon.cause);
      }
    }
    window.addEventListener('unhandledrejection', alFallar);
    return () => window.removeEventListener('unhandledrejection', alFallar);
  }, []);

  if (!mensaje) return null;

  return (
    <div className={estilos.aviso} role="alert">
      <p className={estilos.texto}>
        {mensaje}. Lo que escribiste sigue en pantalla: volvé a intentarlo.
      </p>
      <button type="button" className={estilos.cerrar} onClick={() => setMensaje(null)}>
        Entendido
      </button>
    </div>
  );
}
